export const DEFAULT_MEASUREMENT_COLOR = '#DC143C';
